<div class="references-container">
  <shared-references [references]="pkg()?.references"></shared-references>
</div>
